import React, { CSSProperties, FunctionComponent } from 'react';
import { Label } from 'semantic-ui-react';

type TrustLevel =
  'unverified' | 'moderated' | 'contact-verified' | 'service-verified';

type TrustLevelConfig = {
  label: string;
  variant: 'muted' | 'outline' | 'filled';
};

const TRUST_LEVELS: Record<TrustLevel, TrustLevelConfig> = {
  unverified: {
    label: 'Avis non contrôlé par Bilik',
    variant: 'muted',
  },
  moderated: {
    label: 'Avis vérifié',
    variant: 'outline',
  },
  'contact-verified': {
    label: 'Mise en relation vérifiée',
    variant: 'filled',
  },
  'service-verified': {
    label: 'Prestation vérifiée',
    variant: 'filled',
  },
};

const isTrustLevel = (value: string | null | undefined): value is TrustLevel =>
  !!value && value in TRUST_LEVELS;

type ReviewTrustLevelBadgeProps = {
  trustLevel?: string | null;
  size?: 'mini' | 'small';
  style?: CSSProperties;
};

export const ReviewTrustLevelBadge: FunctionComponent<
  ReviewTrustLevelBadgeProps
> = ({ trustLevel, size = 'small', style }) => {
  if (!isTrustLevel(trustLevel)) return null;

  const config = TRUST_LEVELS[trustLevel];

  return (
    <Label
      size={size}
      color={config.variant === 'muted' ? 'grey' : 'blue'}
      basic={config.variant !== 'filled'}
      style={style}
    >
      {config.label}
    </Label>
  );
};
